"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BaseHeaderContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _mobxReact = require("mobx-react");

var _mobx = require("mobx");

var _extend = _interopRequireDefault(require("lodash/extend"));

var _map = _interopRequireDefault(require("lodash/map"));

var _includes = _interopRequireDefault(require("lodash/includes"));

var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactMotion = require("react-motion");

var _reactClickOutside = _interopRequireDefault(require("react-click-outside"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

// Wraps a component to be used as a expandable menu item in the site header
//
// Note that this should not be mixed with a decorated or otherwise
// observer'd component, as doing so will cause expected observer
// functionality to be lost
var BaseHeaderContext = /*#__PURE__*/(0, _react.createContext)({
  selectedHeaderItem: {},
  isMobileMenu: false,
  enableAnimations: true
});
exports.BaseHeaderContext = BaseHeaderContext;

var HeaderItem = function HeaderItem(superclass, headerItemClassNames) {
  var _class, _descriptor, _descriptor2, _descriptor3, _class2;

  return (0, _reactClickOutside.default)((0, _mobxReact.observer)((_class = (_class2 = /*#__PURE__*/function (_superclass) {
    _inherits(_class, _superclass);

    var _super = _createSuper(_class);

    function _class() {
      var _this;

      _classCallCheck(this, _class);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _initializerDefineProperty(_assertThisInitialized(_this), "isHovering", _descriptor, _assertThisInitialized(_this));

      _initializerDefineProperty(_assertThisInitialized(_this), "isPinned", _descriptor2, _assertThisInitialized(_this));

      _initializerDefineProperty(_assertThisInitialized(_this), "isJustUnpinned", _descriptor3, _assertThisInitialized(_this));

      return _this;
    }

    _createClass(_class, [{
      key: "showChildren",
      get: function get() {
        return this.isHovering && !this.isJustUnpinned || this.isPinned;
      }
    }, {
      key: "handleClickOutside",
      value: function handleClickOutside() {
        this.isPinned = false;
      }
    }, {
      key: "handleClick",
      value: function handleClick(e) {
        if (this.props.children) {
          e.preventDefault();

          if (!this.isPinned) {
            this.isPinned = true;
          } else {
            this.isPinned = false;
            this.isJustUnpinned = true;
          }
        }
      }
    }, {
      key: "handleFocus",
      value: function handleFocus(e) {
        this.isHovering = true;
      }
    }, {
      key: "handleBlur",
      value: function handleBlur(e) {
        this.isHovering = false;
      }
    }, {
      key: "handleMouseEnter",
      value: function handleMouseEnter(e) {
        var _this2 = this;

        this.isJustUnpinned = false;

        if (this.props.showChildrenOnHover) {
          if (this.hoverDelayTimeout) {
            clearTimeout(this.hoverDelayTimeout);
          }

          this.hoverDelayTimeout = setTimeout(function () {
            _this2.isHovering = true;
          }, 300);
        }
      }
    }, {
      key: "handleMouseLeave",
      value: function handleMouseLeave(e) {
        var _this3 = this;

        if (this.hoverDelayTimeout) {
          clearTimeout(this.hoverDelayTimeout);
        }

        this.hoverDelayTimeout = setTimeout(function () {
          _this3.isHovering = false;
        }, 300);
      }
    }, {
      key: "render",
      value: function render() {
        var _this4 = this;

        var headerItemClasses = (0, _classnames.default)("header-item", headerItemClassNames, {
          selected: this.props.name && (0, _includes.default)(this.context.selectedHeaderItem, this.props.name),
          "menu-open": this.showChildren
        });
        var showChildren = this.showChildren || this.context.isMobileMenu;
        var isMobile = !(0, _includes.default)(headerItemClassNames, "mobile-menu-item");
        var springConfig = {
          stiffness: 400,
          damping: 30,
          duration: 400
        };
        var _this$props = this.props,
            enableOnFocus = _this$props.enableOnFocus,
            enableOnMouseEnter = _this$props.enableOnMouseEnter,
            enableOnMouseLeave = _this$props.enableOnMouseLeave;
        return /*#__PURE__*/_react.default.createElement("div", {
          className: headerItemClasses,
          onFocus: enableOnFocus ? this.handleFocus : undefined,
          onMouseEnter: enableOnMouseEnter ? this.handleMouseEnter : undefined,
          onMouseLeave: enableOnMouseLeave ? this.handleMouseLeave : undefined
        }, _get(_getPrototypeOf(_class.prototype), "render", this).call(this), this.props.children && /*#__PURE__*/_react.default.createElement(_reactMotion.TransitionMotion, {
          willEnter: function willEnter() {
            return {
              x: -100
            };
          },
          willLeave: function willLeave() {
            return {
              x: (0, _reactMotion.spring)(-100, springConfig)
            };
          },
          styles: showChildren ? [{
            key: "menu",
            data: this.props.children,
            style: {
              x: (0, _reactMotion.spring)(0, springConfig)
            }
          }] : []
        }, function (interpolatedStyles) {
          return _this4.context.disableTransform ? /*#__PURE__*/_react.default.createElement("div", {
            className: "sub-item-container"
          }, (0, _map.default)(interpolatedStyles, function (_ref) {
            var data = _ref.data,
                key = _ref.key;
            var children = data;
            return /*#__PURE__*/_react.default.createElement("div", {
              key: key,
              className: "sub-items"
            }, children);
          })) : /*#__PURE__*/_react.default.createElement("div", {
            className: "sub-item-container animated-sub-item-container"
          }, (0, _map.default)(interpolatedStyles, function (_ref2) {
            var data = _ref2.data,
                key = _ref2.key,
                style = _ref2.style;
            var children = data;
            return /*#__PURE__*/_react.default.createElement("div", {
              key: key,
              className: "sub-items",
              style: _this4.context.enableAnimations && isMobile ? {
                transform: "translate3d(0, ".concat(style.x, "%, 0)")
              } : {
                transform: "translate3d(".concat(style.x, "%, 0, 0)")
              }
            }, children);
          }));
        }));
      }
    }]);

    return _class;
  }(superclass), _defineProperty(_class2, "propTypes", (0, _extend.default)({}, {
    minimizable: _propTypes.default.bool,
    showChildrenOnHover: _propTypes.default.bool,
    enableOnFocus: _propTypes.default.bool,
    enableOnMouseEnter: _propTypes.default.bool,
    enableOnMouseLeave: _propTypes.default.bool
  }, superclass.propTypes)), _defineProperty(_class2, "contextType", BaseHeaderContext), _defineProperty(_class2, "defaultProps", (0, _extend.default)({}, {
    minimizable: true,
    showChildrenOnHover: false,
    enableOnFocus: true,
    enableOnMouseEnter: true,
    enableOnMouseLeave: true
  }, superclass.defaultProps)), _class2), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "isHovering", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isPinned", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "isJustUnpinned", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "showChildren", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showChildren"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleClickOutside", [_autobindDecorator.default, _mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleClickOutside"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleClick", [_autobindDecorator.default, _mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleFocus", [_autobindDecorator.default, _mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleFocus"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleBlur", [_autobindDecorator.default, _mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleBlur"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleMouseEnter", [_autobindDecorator.default, _mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleMouseEnter"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleMouseLeave", [_autobindDecorator.default, _mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleMouseLeave"), _class.prototype)), _class)));
};

var _default = HeaderItem;
exports.default = _default;